import isEmpty from "lodash/isEmpty";

export const logoMappedProductMatchesRemoval = (mappedProduct, productId, colorId) => {
  const pid = Number(productId);
  if (colorId == null) {
    if (Number(mappedProduct?.productId) === pid) return true;
    return false;
  }

  const cid = Number(colorId);
  if (Number(mappedProduct?.productId) === pid && Number(mappedProduct?.optionValueId) === cid) {
    return true;
  }
  return false;
};

export const serializeDraftCatalogProducts = (products = []) => {
  return products.map((product) => ({
    ...product,
    productId: Number(product?.id),
    baseImage: product?.images?.[0],
    brand: product?.brand?.name ? { displayName: product.brand.name } : product?.brand,
  }));
};

export const productMatchesId = (product, productId) => {
  const pid = Number(productId);
  return Number(product?.id) === pid || Number(product?.productId) === pid;
};

export const stripColorOptionFromProduct = (product, colorIdToRemove) => {
  const cid = Number(colorIdToRemove);
  const selectedColorOptions = (product.selectedColorOptions || []).filter(
    (option) => Number(option?.id) !== cid,
  );
  const selectedColorsWithTemplate = (product.selectedColorsWithTemplate || []).filter(
    (row) => Number(row?.optionValue?.id) !== cid,
  );
  return {
    ...product,
    selectedColorOptions,
    selectedColorsWithTemplate,
  };
};

export const buildCollectionAfterColorRemoval = (collection, productId, colorIdToRemove) => {
  return collection
    .map((product) => {
      if (!productMatchesId(product, productId)) return product;
      const updated = stripColorOptionFromProduct(product, colorIdToRemove);
      return !isEmpty(product.selectedColorOptions) ? updated : null;
    })
    .filter(Boolean);
};

export const buildAutomatedCatalogLogosMappingInput = (swagLogos) => {
  return swagLogos.map((logo) => {
    const logoId = Number(logo.logoId ?? logo.id);
    if (logo.isLogoAppliedToAllProducts) {
      return {
        logoId,
        applyToUnmapped: true,
      };
    }
    const productMap = {};
    logo.products.forEach(({ productId, optionValueId }) => {
      const pid = Number(productId);
      if (!pid) return;
      if (!productMap[pid]) {
        productMap[pid] = { productId: pid, colorIds: [] };
      }
      if (optionValueId != null) {
        const oid = Number(optionValueId);
        if (Number.isFinite(oid) && !productMap[pid].colorIds.includes(oid)) {
          productMap[pid].colorIds.push(oid);
        }
      }
    });
    const selectedProducts = Object.values(productMap).map(({ productId: pid, colorIds }) => ({
      productId: pid,
      ...(colorIds.length ? { colorIds } : {}),
    }));
    return {
      logoId,
      selectedProducts,
    };
  });
};

/** Flatten draft catalog products to per-color rows (matches add-logo product selection panel). */
export const flattenDraftCatalogColorProducts = (swagCollection = []) => {
  return swagCollection.flatMap((product) => {
    const selectedColors = product.selectedColorsWithTemplate || [];

    if (selectedColors.length === 0) {
      return [
        {
          id: `${product.productId}`,
          productId: product.productId,
          optionValueId: null,
          name: product.name,
          colorName: null,
          image: product.baseImage,
        },
      ];
    }

    return selectedColors.map((colorTemplate) => ({
      id: `${product.productId}:${colorTemplate.optionValue.id}`,
      productId: product.productId,
      optionValueId: Number(colorTemplate.optionValue.id),
      name: product.name,
      colorName: colorTemplate.optionValue.presentation || colorTemplate.optionValue.name,
      image: colorTemplate.images?.[0] || product.baseImage,
    }));
  });
};

export const getAssignedProductIdsFromLogos = (swagLogos = []) => {
  const ids = new Set();
  swagLogos.forEach((logo) => {
    (logo.products || []).forEach((product) => ids.add(product.id));
  });
  return ids;
};
